import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { LearnedPresetKind } from "@redotech/redo-fulfillment-outbound-labels-common/outbound-label-enums";
import { FulfillmentGroupUpdate } from "@redotech/redo-merchant-fulfillment-rpc/schema/update-fulfillment-groups";

export function shouldRecalculateRatesForUpdate(
  update: FulfillmentGroupUpdate,
) {
  return Boolean(
    update.selectedParcels ||
    update.signatureRequired != null ||
    update.adultSignatureRequired != null ||
    update.customsDeclarations ||
    update.contentsType ||
    update.contentsExplanation ||
    update.nonDeliveryOption ||
    update.uspsExemptionCode ||
    update.taxIdentifierIds ||
    update.customerTaxIds ||
    update.itn ||
    update.ddp != null ||
    update.hazmat !== undefined ||
    update.dryIceWeight !== undefined ||
    update.saturdayDelivery !== undefined ||
    update.specialRateEligibility !== undefined ||
    update.assignedFulfillmentService ||
    update.shipmentPaymentOption !== undefined ||
    update.directDeliveryOnly !== undefined ||
    update.carbonNeutral !== undefined ||
    update.canadaPostOption !== undefined ||
    update.dhlEcommerceLabelOptions !== undefined ||
    update.additionalCustomsComments !== undefined ||
    update.overrideResidentialAddress !== undefined,
  );
}

export function getOptimisticUpdates(
  originalData: FulfillmentGroupData[],
  updates: FulfillmentGroupUpdate[],
) {
  const newData = [...originalData];
  for (const { fulfillmentGroupId, ...rest } of updates) {
    const index = newData.findIndex((row) => row._id === fulfillmentGroupId);
    if (index < 0) {
      continue;
    }
    const fulfillmentGroupUpdate = { fulfillmentGroupId, ...rest };
    const update: Partial<FulfillmentGroupData> = { ...rest };
    if (shouldRecalculateRatesForUpdate(fulfillmentGroupUpdate)) {
      update.ratesPendingSince = new Date();
    }
    // Picking a personalized insert kicks off async generation; show the
    // generating state immediately (cleared when "No personalized insert").
    if (rest.personalizedSlipTemplateId !== undefined) {
      update.personalizedSlipGeneratingSince = rest.personalizedSlipTemplateId
        ? new Date()
        : null;
    }
    // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
    newData[index] = { ...newData[index], ...update };
    if (rest.overrideDeliveryMethod) {
      // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
      newData[index].deliveryMethod = rest.overrideDeliveryMethod;
    }
    if (update.ratesPendingSince || rest.selectedShippingRate !== undefined) {
      // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
      newData[index].buyLabelErrors = [];
    }
    if (rest.displayWeightGrams && newData?.[index]?.usedLearning != null) {
      newData[index].usedLearning[LearnedPresetKind.WEIGHT] = false;
    }
    if (rest.selectedParcels && newData?.[index]?.usedLearning != null) {
      newData[index].usedLearning[LearnedPresetKind.PARCEL] = false;
    }
    const weightOverrideChanged = rest.selectedParcels?.some(
      (parcel) => parcel.parcelAndContentWeight !== undefined,
    );
    if (weightOverrideChanged && newData?.[index]?.usedLearning != null) {
      newData[index].usedLearning[LearnedPresetKind.WEIGHT] = false;
    }
    if (
      (rest.selectedShippingRate || rest.selectedShippingRate === null) &&
      newData?.[index]?.usedLearning != null
    ) {
      newData[index].usedLearning[LearnedPresetKind.CARRIER_SERVICE_LEVEL] =
        false;
    }
  }
  return { newData, updates };
}
